'use client';

import { DataTestIdEnum } from '@medprev-web-app/datatestid';

import { CartEntityHeader } from './cart-entity-header.component';

import { CartItem } from '@/types/cart.types';
import { EntityTypeEnum } from '@/types/enums/entity-type.enum';
import { professionalDisplayName } from '@/utils/formatters/professional-name';
import { formatToTitleCase } from '@/utils/formatters/format-to-title-case';

interface CartItemHeaderProps {
  item: CartItem;
  dataTestId?: string;
}

export function CartItemHeader({
  item,
  dataTestId = DataTestIdEnum.CART_ITEM_PROFESSIONAL,
}: CartItemHeaderProps) {
  const { professional, partner } = item;

  const name = professional
    ? professionalDisplayName({
        honorific: professional.honorific,
        name: professional.socialName || professional.legalName,
      })
    : formatToTitleCase(partner.socialName);

  return (
    <CartEntityHeader
      name={name}
      avatar={professional ? professional.avatar : partner.avatar}
      entityType={professional ? EntityTypeEnum.PROFESSIONAL : EntityTypeEnum.LABORATORY_COLLECT_POINT}
      dataTestId={dataTestId}
    />
  );
}
